// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const RgaDetails = t.struct({
    analysisDate: t.Number,
    analysisFailureMode: t.String,
    analysisStatus: t.String,
    analystId: t.String,
    attentionLine: t.String,
    componentSerialNumber: t.String,
    createdBy: t.String,
    createdTimestamp: t.Number,
    dtacCaseNumber: t.String,
    engineHours: t.Number,
    engineSerialNumber: t.String,
    failureDescription: t.String,
    failureMechanismRca: t.String,
    family: t.String,
    findings: t.String,
    followUpDate: t.Number,
    logNumber: t.String,
    machineHours: t.Number,
    machineSerialNumber: t.String,
    manufacturedDate: t.Number,
    manufacturingCode: t.String,
    model: t.String,
    nccaCarNo: t.String,
    partDescription: t.String,
    partGroup: t.String,
    partNumber: t.String,
    partReceiveDate: t.Number,
    platform: t.String,
    processedDate: t.Number,
    requestedDate: t.Number,
    requestedPartQuantity: t.Number,
    requesterType: t.Number,
    responsibleGroup: t.String,
    responsibleUnit: t.String,
    returnedPartNumber: t.String,
    returnedPartQuantity: t.String,
    rgaNumber: t.String,
    rgaRecallStatus: t.String,
    rgaSubType: t.String,
    subSystem: t.String,
    supplier: t.String,
    updatedBy: t.String,
    updatedTimestamp: t.Number,
    warrantyClaimNumber: t.String
}, {
    name: 'RgaDetails',
    strict: true
});

export const getDefaultState = () => new RgaDetails({
    analysisDate: 0,
    analysisFailureMode: '',
    analysisStatus: '',
    analystId: '',
    attentionLine: '',
    componentSerialNumber: '',
    createdBy: '',
    createdTimestamp: 0,
    dtacCaseNumber: '',
    engineHours: 0,
    engineSerialNumber: '',
    failureDescription: '',
    failureMechanismRca: '',
    family: '',
    findings: '',
    followUpDate: 0,
    logNumber: '',
    machineHours: 0,
    machineSerialNumber: '',
    manufacturedDate: 0,
    manufacturingCode: '',
    model: '',
    nccaCarNo: '',
    partDescription: '',
    partGroup: '',
    partNumber: '',
    partReceiveDate: 0,
    platform: '',
    processedDate: 0,
    requestedDate: 0,
    requestedPartQuantity: 0,
    requesterType: 0,
    responsibleGroup: '',
    responsibleUnit: '',
    returnedPartNumber: '',
    returnedPartQuantity: '',
    rgaNumber: '',
    rgaRecallStatus: '',
    rgaSubType: '',
    subSystem: '',
    supplier: '',
    updatedBy: '',
    updatedTimestamp: 0,
    warrantyClaimNumber: ''
});

RgaDetails.prototype.stripLeadingZerosForRgaNumber = function stripLeadingZerosForRgaNumber() {

    const strippedRgaNumber = this.rgaNumber.replace(/^0+/, '');

    return strippedRgaNumber;

};

export default RgaDetails;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-details.js